module.exports = __webpack_public_path__ + "static/media/verdana.5587517d.ttf";